<template>
    <div name="showcase" class="wrapper" :class="showcaseClass">
        <router-view></router-view>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'showcase',
    computed: {
        ...mapGetters('theme', ['currentShowcase']),
        showcaseClass() {
            return this.currentShowcase ? `theme-${this.currentShowcase}` : ''
        }
    },
    watch: {
        '$route.params.showcase': {
            immediate: true,
            handler(showcaseName) {
                if (showcaseName) {
                    this.setTheme(showcaseName)
                }
            }
        }
    },
    methods: {
        ...mapActions('theme', ['setTheme'])
    }
}
</script>

<style scoped>
    .wrapper {
        height: 100dvh;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/page/showcase/Showcase.vue